import Operators from "../pages/Operators/Operators";
import AddOperator from "../containers/AddOperator/AddOperator";
import SpecificOperatorWallet from "../containers/OperatorDetails/SpecificOperatorWallet/SpecificOperatorWallet";
import OperatorAssignCover from "../containers/OperatorDetails/OperatorAssignCover/OperatorAssignCover";
import OperatorAssignCommission from "../containers/OperatorDetails/OperatorAssignCommission/OperatorAssignCommission";
import PolicedIssuedByOperator from "../containers/OperatorDetails/PolicedIssuedByOperator/PolicedIssuedByOperator";
import OperatorPayments from "../containers/Payments/Payments";
import TripDetails from "../../issuance/containers/TripTravellerDetail/TripDetails";

// Common Routes
const commonRoutes = [
  { path: "wallet", element: <SpecificOperatorWallet /> },
  { path: "operator-assign-covers", element: <OperatorAssignCover /> },
  { path: "commission", element: <OperatorAssignCommission /> },
  { path: "payments", element: <OperatorPayments /> },
  { path: "policies-issued", element: <PolicedIssuedByOperator /> },
  { path: "policies-issued/:id", element: <TripDetails /> },
];

// Helper to prefix paths with 'user/users/'
const withLayout = (children) => {
  return children.map((route) => ({
    ...route,
    path: `operator/operator-details/${route.path}`,
  }));
};

// Main operator routes (no conditionals, no layout)
const OperatorDetailRoutes = [
  { path: "operator/operator-details", element: <Operators /> },
  { path: "operator/operators/create", element: <AddOperator /> },
  ...withLayout(commonRoutes),
];

export default OperatorDetailRoutes;